<template>
  <b-sidebar bg-variant="white" id="deal-sidebar" no-header right shadow @shown="getDeal">
    <div class="px-3 py-2">
      <i class="fas fa-close position-absolute" v-b-toggle.deal-sidebar></i>
      <div class="p-3 mt-3">
        <img src="/img/integrations/fub-logo.png" class="w-100 mb-2 integration-logo" />
      </div>
      <div v-if="deal">
        <h3 class="mb-0">{{ deal.name }}</h3>
        <p class="small">{{ deal.pipelineName }} <i class="fas fa-angle-double-right"></i> {{ deal.stageName }}</p>
        <p class="small mb-0"><strong>Price:</strong> {{ deal.price | currency }}</p>
        <p class="small mb-0"><strong>Close Date:</strong> {{ new Date(deal.projectedCloseDate) | date("MMM dd, Y") }}</p>
        <p class="small mb-0"><strong>Commission:</strong> {{ deal.commissionValue | currency }}</p>
        <p class="small"><strong>Team Commission:</strong> {{ deal.teamCommission | currency }}</p>
        <b-row class="mb-3">
          <b-col md="6">
            <h4>People:</h4>
            <b-avatar-group size="45px">
              <b-avatar v-for="person in deal.people" :text="initials(person.name)" :src="person.avatar" :key="person.id" variant="primary"></b-avatar>
            </b-avatar-group>
          </b-col>
          <b-col md="6">
            <h4>Team:</h4>
            <b-avatar-group size="45px">
              <b-avatar v-for="user in deal.users" :text="initials(user.name)" :src="user.avatar" :key="user.id" variant="primary"></b-avatar>
            </b-avatar-group>
          </b-col>
        </b-row>
        <h4>Description:</h4>
        <div class="small">{{ deal.description }}</div>
      </div>
      <loading-panel v-else></loading-panel>
    </div>
  </b-sidebar>
</template>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex';
import LoadingPanel from '@/components/LoadingPanel';

export default {
  props: {
    dealId: null,
    userRoute: null
  },
  components: {
    LoadingPanel
  },
  data() {
    return {
      deal: null
    }
  },
  methods: {
    getDeal() {
      axios.get(this.userRoute + "/integrations/fub/deals/" + this.dealId)
      .then(response => {
        this.deal = response.data;
      })
      .catch(error => {
        // error
      });
    },
    initials(name) {
      let person = name.split(" ");

      return Array.from(person[0])[0] + Array.from(person[1])[0];
    }
  }
};
</script>